import "./style.scss";
import AddElement from "../AddElement";
import { useAppSelector } from "../../../store/store";
import EditElement from "../EditElement";
import AssistantSideBar from "@builder/assist/ui/AssistantSideBar";
// import ConditionsSidebar from "@builder/components/app/Conditions";

const leftSidebarMap = {
    addElement: <AddElement />,
    editElement: <EditElement />,
    // conditions: <ConditionsSidebar />,
    actions: "Actions",
    assistant: <AssistantSideBar />
};

const OliverLeftSidebar: React.FC = () => {
    const leftSidebarInstance = useAppSelector(state => state.sidebar.leftSidebar.instance);

    return <div className="oliver-left-sidebar">{leftSidebarMap[leftSidebarInstance]}</div>;
};

export default OliverLeftSidebar;
